import { hydrate } from '@solidjs/web';
import { DefaultErrorBoundary } from "virtual:solid-ssr-error-boundary.tsx";
import Document from "/opt/buildhome/repo/site/src/Document.tsx";
import App from "/opt/buildhome/repo/site/src/App.tsx";

hydrate(() => (
  <DefaultErrorBoundary>
    <Document>
      <DefaultErrorBoundary>
        <App />
      </DefaultErrorBoundary>
    </Document>
  </DefaultErrorBoundary>
), document);